import { render, staticRenderFns } from "./NeuroChart.vue?vue&type=template&id=4a826b38&scoped=true&"
import script from "./NeuroChart.vue?vue&type=script&lang=js&"
export * from "./NeuroChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a826b38",
  null
  
)

export default component.exports